export default __webpack_public_path__ + "static/media/camera.813a17c4.png";